import request from '@/utils/request'
// 获取红外探测设备列表
export const getIrDetectionList = (data) => {
    return request({
        url: '/HVAC/ir_detection/lists',
        params: data
    })
}
// 添加红外探测设备
export const addIrDetection = (data) => {
    return request({
        url: '/HVAC/ir_detection/manage',
        method: 'POST',
        data
    })
}
// 编辑红外探测设备
export const editIrDetection = (data) => {
    return request({
        url: '/HVAC/ir_detection/manage',
        method: 'PUT',
        data
    })
}
// 删除红外探测设备

export const deleteIrDetection = (id) => {
    return request({
        url: `/HVAC/ir_detection/${id}`,
        method: 'DELETE'
    })
}
// 获取红外探测设备列表历史数据
export const getIrDetectionReportData = (data) => {
    return request({
        url: '/HVAC/ir_detection/report_data',
        params: data
    })
}
